/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * 5746-SM2
 *
 * (C) Copyright IBM Corp. 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function() {

	return {

		/**
		 * check if the sources in the spec have authoring capability
		 * @param {object} dashboardApi - dashboardAPI
		 * @param {object} spec - dashoard or fragment spec
		 * @param {object} spec.dataSources - dataSources property of the spec
		 * @param {object[]} spec.dataSources.sources - array of sources
		 * @param {string} spec.dataSources.sources[i].assetId - asset id of the source element
		 * @param {string} spec.dataSources.sources[i].type - asset type of the source element
		 * @param {string} capabilityErrorMsg - error to show in the toast for deny capability result
		 * @returns {Promise<boolean>} promise that resolves true if all sources in the spec have authoring capability, false otherwise; and rejects for unexpected errors
		 */
		checkAuthoringCapability(dashboardApi, spec, capabilityErrorMsg) {
			const capabilitiesFeature = dashboardApi.getFeature('Capabilities');
			if (!capabilitiesFeature) {
				return Promise.resolve(true);
			}
			return capabilitiesFeature.checkAuthoringCapability({ spec })
				.then((hasCapability) => {
					if (!hasCapability) {
						dashboardApi.showToast(capabilityErrorMsg, {
							type: 'error',
							preventDuplicates: true
						});
					}
					return hasCapability;
				});
		},

		/**
		 * check if the dashboard to be saved contains data sources that user does not have authoring capability
		 * @param {context} the context that contains the dashboard to be saved
		 * @returns {Promise<boolean>} promise that resolves true if all sources in the dashboard spec have authoring capability, false otherwise; and rejects for unexpected errors
		 */
		hasCapabilityToSaveDashboard(context) {
			const dashboardView = context.glassContext.appController.currentAppView.currentContentView;
			if (dashboardView.isAuthoringMode) {
				return Promise.resolve(true);
			}
			const stringResources = dashboardView.services.getSvcSync('.StringResources');
			return this.checkAuthoringCapability(dashboardView.getDashboardApi(), dashboardView.boardSpec, stringResources.get('noCapabilityForSave'))
				.catch((err) => {
					context.glassContext.getCoreSvc('.Logger').error('Fail to check source capability in Save', err);
					return false;
				});
		}
	};

});
